import React from "react";

import type { Option } from "@storeblocks/select";
import { Select } from "Components/Form/Select";
import { useTexts } from "Components/TextContext";
import { TextLanguage } from "Store/texts/interfaces";
import { getError } from "Utils/productUtils";
import { useFormikContext } from "formik";
import { CarPriceFormValues } from "../interfaces";

interface Props {
  readonly updatePrices: (field: string, value: string) => void;
  readonly texts: any;
  readonly lang: TextLanguage;
  readonly isEmployee: boolean;
}

export const ExpectedYearlyUsage = (
  props: Props,
): React.ReactElement | null => {
  const formProps = useFormikContext<CarPriceFormValues>();
  const { updatePrices, texts, lang, isEmployee } = props;
  const { getText } = useTexts();

  if (isEmployee) {
    return null;
  }

  return (
    <Select
      id="yearlyKmNeed"
      name="yearlyKmNeed"
      label={texts.yearlyKmNeed.label[lang]}
      options={getYearlyKmNeedOptions(texts.yearlyKmNeed.options)}
      error={getError("yearlyKmNeed", formProps)}
      onChange={(event) => updatePrices(event.target.name, event.target.value)}
      large
      labelPopoverProps={{
        children: <div>{getText("carform.hint.yearlykmneed")}</div>,
      }}
    />
  );
};

const getYearlyKmNeedOptions = (options: any): Option[] => {
  const kmData: Array<{ value: string; label: string }> = options.km.map(
    (option: { name: string; value: string }): Option => ({
      label: option.name,
      value: option.value,
    }),
  );

  return [...kmData];
};
